import FyaiFooter from "@/components/feature/fyai-footer";
import FyaiHeader from "@/components/feature/fyai-header";
import { useFyaiSeo } from "@/hooks/useFyaiSeo";
import FyaiCharacters from "./components/FyaiCharacters";
import FyaiDownloadTip from "./components/FyaiDownloadTip";
import FyaiFaq from "./components/FyaiFaq";
import FyaiFeatures from "./components/FyaiFeatures";
import FyaiHero from "./components/FyaiHero";
import FyaiHighlights from "./components/FyaiHighlights";
import FyaiScreenshots from "./components/FyaiScreenshots";

export default function Home() {
  useFyaiSeo({
    title: "风月AI官网 - 专注细腻聊天的情感陪伴",
    keywords: "风月AI",
    description:
      "风月AI官网（fengyueaiapp.net）是风月AI聊天软件的官方下载入口。AI风月带来沉浸式情感陪伴与角色扮演聊天，Android、iOS、HarmonyOS、Windows全平台支持，快来风月AI开启与TA的另一段人生吧~",
    path: "/",
  });

  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-hidden bg-background-50">
      <FyaiHeader />
      <main className="w-full flex-1">
        <FyaiHero />
        <FyaiFeatures />
        <FyaiCharacters />
        <FyaiScreenshots />
        <FyaiHighlights />
        <FyaiDownloadTip />
        <FyaiFaq />
      </main>
      <FyaiFooter isHome />
    </div>
  );
}